export default function Loading({ label = "Saddling up…" }) {
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-[#f8f9fa]" data-testid="app-loading">
      <div className="horse-loading text-6xl" aria-hidden>🐎</div>
      <div className="mt-4 font-display font-extrabold text-lg text-[#212529]">HorseTips4fun</div>
      <div className="text-sm text-[#6c757d] mt-1">{label}</div>
    </div>
  );
}
